import React from 'react';
import { Link } from 'react-router';

export default (
  <div>
    <h1>Vilkår og retningslinjer for Boligninja.dk</h1>
    <h3>Oplysninger om os</h3>
    <p>
      Boligninja ApS
      <br />
      Niels Bohrs Vej 61
      <br />
      8660 Skanderborg
      <br />
      <br />
      CVR nr. DK 37 14 89 97
      <br />
      <br />
      E-mail: info@boligninja.dk
      <br />
      <br />
      Hjemsted: Skanderborg
    </p>
    <h3>Generelt</h3>
    <p>
      Boligninja.dk stilles til rådighed for dets brugere, under forudsætning
      af, at &quot;Vilkår og retningslinjer for Boligninja.dk&quot; (herefter
      kaldet &quot;vilkårene&quot;) overholdes. Boligninja.dk stilles
      udelukkende til rådighed for brugerens personlige boligsøgning, og må
      således ikke benyttes til andre formål uden forudgående skriftlig aftale.
    </p>
    <h3>Dine personlige oplysninger</h3>
    <p>
      Når du opretter dig som bruger på Boligninja.dk, behandler vi dine
      oplysninger oplysninger fortroligt, og videregiver ikke dine personlige
      oplysninger til tredjemand uden din personlige accept. Vi behandler dine
      personlige oplysninger i overensstemmelse med Personoplysningsloven.
    </p>
    <p>
      De oplysninger, som du afgiver i forbindelsemed oprettelse af din
      brugerkonto, skal være ægte og tilhøre dig selv. Det er dit ansvar, at
      dine personlige oplysninger altid er korrekte, når du bruger
      Boligninja.dk, og du er derfor ansvarlig for at opdatere dem, hvis de
      ændres. Du kan til enhver tid selv ændre eller slette dine personlige
      oplysninger. Den oplyste email skal vlre kontrolleret af dig, og det er
      således ikke tilladt at benytte en e-mailadresse fra en udbyder, som
      tilbyder e-mail uden registrering. Afgivelse af falske oplysninger er i
      strid med vilkårene.
    </p>
    <h3>Anvendelse</h3>
    <p>
      Din brugerkonto og de dertilhørende services er strengt personlige. Det er
      ikke tilladt at dele, udlåne, videresælge eller på anden måde videregive
      oplysninger om sin brugerkonto, der kan give andre adgang til servicen, og
      du må kun søge bolig på vegne af dig selv eller én husstand. Det er ikke
      tilladt at benytte en brugerkonto til automatisk eller maskinelt at tilgå
      oplysninger på Boligninja.dk - automatisk og maskinel adgang til data
      tilbydes mod betaling og på licens fra Boligninja ApS.
    </p>
    <h3>Produkt</h3>
    <p>
      Boligninja.dk er en online service, som skaber kontakt mellem
      boligudlejere og boligsøgende.
    </p>
    <h3>Boligsøgerannonce (abonnement)</h3>
    <p>
      Boligninja.dk giver dets brugere mulighed for at oprette en
      boligsøgerannonce. Oprettelse af en boligsøgerannonce giver adgang til
      lejemål og kontaktoplysninger på udlejere. Brugeren får samtidig besked om
      nye lejemål før brugere, som ikke har en boligsøgerannonce
    </p>
    <p>For at oprette en boligsøgerannonce, skal du være fyldt 18 år.</p>
    <h3>Betaling</h3>
    <p>
      Alle oplyste priser er inklusiv 25% dansk moms, og der gælder de priser,
      som er angivet i forbindelse med et køb, med undtagelse af åbenlyse (fx
      typografiske) fejl. Enhver betaling til Boligninja.dk sker gennem vores
      betalingsudbyder (Paylike) via en krypteret forbindelse, og vil ikke blive
      pålagt et kortgebyr. Betalingen vil altid være omfattet af meget høj
      datasikkerhed, og kortoplysninger sendes udelukkende til
      betalingsudbyderen.
    </p>
    <p>
      Udløber det betalingskort, der er angivet ved indgåelse af
      abonnementsaftalen, eller bliver det på anden vis spærret, så vi ikke kan
      trække den periodevise betaling, vil vi forsøge at foretage en trækning i
      en periode herefter, varierende afhængig af årsagen til den oprindeligt
      fejlede trækning. Lykkes det ikke at foretage en ny trækning inden for
      denne periode, forbeholdes retten til at sætte abonnementet i bero og
      ultimativt stoppe det.
    </p>
    <h3>Abonnement</h3>
    <p>
      Boligsøgerannoncen er abonnementsbaseret. Når du tilmelder dig
      boligsøgerannoncen, fornyer vi automatisk abonnementer ved udløb af den
      igangværende periode, indtil abonnementet opsiges. Perioden starter fra
      Købstidspunktet, og der er forløbet én dag, når der er gået 24 timer. Du
      opkræves ved hver fornyelse det aftalte beløb for den nye påbegyndte
      periode.
    </p>
    <h3>Opsigelse og binding</h3>
    <p>
      Det er muligt at afmelde abonnementet helt fremt til tidspunktet for den
      automatiske fornyelse. Afmeldingen skal enten foretages via brugerens
      profilside eller skrifteligt via mail. Uanset hvordan afmeldingen
      foretages, er det vigtigt, at brugeren gemmer en kopi af sin
      afmeldingskvittering, som dokumentation for afmeldingen. Efter gennemført
      afmeldingen, vil brugerens abonnement være aktivt frem til udløbet af den
      indeværende periode.
    </p>
    <h3>Levering</h3>
    <p>
      Abonnementet aktiveres i det øjeblik, betalingen er gennemført. Når du
      opretter en boligsøgerannonce hos Boligninja.dk træder anvendelsen af
      produktet derfor i kraft i det øjeblik, at betalingen er gennemført.
    </p>
    <h3>Fortrydelsesret og reklamationsret</h3>
    <p>
      Du har 14 dages fortrydelsesret ved køb Boligninja’s online services. For
      køb af tjenesteydelser gælder fortrydelsesretten fra det øjeblik, aftalen
      blev indgået. Fortrydelsesretten bortfalder dog ved ibrugtagning af
      tjenesteydelser/services. Ønsker du at gøre brug af fortrydelsesretten,
      skal du senest 14 dage efter købet kontakte vores kundeservice med ønsket
      om at fortryde købet. Du kan kontakte Boligninja’s kundeservice på
      info@boligninja.dk
    </p>
    <p>
      I forbindelse med køb på Boligninja.dk ydes reklamationsret, hvis ydelsen
      mod forventning skulle være mangelfuld eller fejlbehæftet. Fejlagtig brug
      af en ydelse er ikke en fejl ved produktet. Såfremt reklamationsretten
      ønskes benyttet, skal Boligninja kontaktes inden rimelig tid, med en
      udførlig beskrivelse af årsagen til reklamationen.
    </p>
    <h3>Tilbagebetaling</h3>
    <p>
      Hvis du fortryder sit køb, får du dine penge tilbage. Vi refunderer
      beløbet til dig uden nødig forsinkelse og senest 14 dage fra den dag, hvor
      vi har modtaget besked om, at du vil fortryde aftalen. Vi tilbagefører
      pengene med det samme betalingsmiddel, som du benyttede ved købet,
      medmindre vi har aftalt andet.
    </p>
    <h3>Ændring af vilkår</h3>
    <p>Boligninja.dk forbeholder sig ret til at opdatere vilkårerne løbende.</p>
    <h3 id="elektronisk-kommunikation">Elektronisk kommunikation</h3>
    <p>
      Accepterer du at modtage beskeder fra Boligninja.dk, giver du samtykke til
      at modtage elektronisk kommunikation via e-mail, SMS, push-notifikationer
      på smartphone og browser, Facebook, Messenger, Snapchat og Whatsapp,
      såfremt du har givet os de nødvendige oplysninger til at kunne servicere
      dig med elektronisk kommunikation via disse medier også.
    </p>
    <p>
      Den elektroniske kommunikation indebærer servicebeskeder og Boligagent
      beskeder med informationer om nye boliger. Derudover kan du modtage
      elektronisk kommunikation relateret til alarmer, apps, banker,
      dagtilbud/skoler mv., ejendomsmæglere, finansiering, flytning,
      flyttefirmaer, forsikring, forsyningsselskaber, fritidsaktiviteter,
      håndværkere, indbrudssikring, indretning, internetforbindelser, inventar,
      istandsættelse, juridisk bistand, leje af bil og trailer, levering af
      fødevarer, magasiner/aviser, malerfirmaer, møbler, opbevaring, sparetips,
      streaming, telefoni, træning, trailer til flytning, tv og
      uddannelsesinstitutioner.
    </p>
    <p>
      Beskederne kan afmeldes via afmeldingslinket sidst i de beskeder - som
      eksempel kommer i form af e-mails og SMS - du modtager eller via &quot;Min
      profil&quot; på Boligninja.
    </p>
    <h3>Ansvar</h3>
    <p>
      Boligninja ApS står ikke for selve udlejningen af boligerne, og er derfor
      ikke ansvarlig for fejlagtige oplysninger i udlejernes annoncer eller fejl
      og mangler ved de udlejede boliger.
    </p>
    <h3>Træk på dit kort</h3>
    <p>
      Du kan til enhver tid tilbagekalde din tilladelse til, at Boligninja. dk
      trækker et beløb på dit kort.Når du har tilbagekaldt din tilladelse, vil
      du stadig have et aktivt abonnement hos os. Hvis du ikke længere ønsker,
      at have et aktivt abonnement, ska du afmelde det. Du kan læse, hvordan du
      afmelder abonnementet i det tidligere afsnit om opsigelse og binding.
    </p>
    <p>
      Du kan også gøre indsigelse vedrørende "uautoriserede debiteringer" over
      for din kortudbyder, hvis du oplever trækninger på din konto, som du ikke
      har givet tilladelse til. Dette skal du gøre senest 8 uger efter
      debiteringen, med mindre andet fremgår af din aftale med udbyderen. Vi
      anbefaler dog, at du kontakter os først, så vi kan hjælpe dig med at finde
      en løsning. Dette vil ofte både være hurtigere og nemmere end at løse
      problemet gennem banken.
    </p>
    <h3>Misligholdelse</h3>
    <p>
      Vi forbeholder os retten til at blokere for din adgang og begrænse et
      eventuelt tab, hvis vi har en begrundet mistanke om, at du ikke overholder
      vores vilkår.
    </p>
    <h3>Tredjeparts websteder</h3>
    <p>
      Dette website kan indeholde links til hjemmesider, der drives af en af
      vores partnere, annoncører eller tilknyttede selskaber eller andre
      tredjeparter. Bemærk, at vi ikke er ansvarlige for indholdet af sådanne
      hjemmesider eller de varer eller tjenester, der tilbydes der.
    </p>
    <h3>Immateriel ejendomsret</h3>
    <p>
      Boligninja.dk eller vores licensgivere ejer alle immaterielle rettigheder
      til Websitet og alle materialer lagt ud på Websitet. Disse rettigheder og
      materialer er beskyttet af copyright og enhver ret i denne forbindelse
      forbeholdes.
    </p>
    <p>
      Du kan til personlig brug udskrive en kopi eller downloade uddrag af sider
      på Websitet. Du må ikke bruge nogen del af vores ophavsretligt beskyttede
      materiale til kommercielle formål uden først at indhente en licens fra os
      eller vores licensgivere.
    </p>
    <p>
      Ved oprettelse af indhold på Boligninja.dk, så giver du Boligninja.dk og
      hermed koncernforbundne selskaber en ubegrænset, vederlagsfri,
      uigenkaldelig og overdragelig ret til at tilgængeliggøre, ændre og
      fremstille eksemplarer af hele eller dele af det pågældende indhold,
      herunder data, tekst og billeder. Intet i disse vilkår begrænser dine
      rettigheder til selv at anvende det indhold, herunder data, tekst og
      billeder, som du opretter på Boligninja.dk.
    </p>
    <em>Senest opdateret: 27. august 2019</em>
  </div>
);
